import { useState } from 'react'
import { useSelector } from 'react-redux';
import autoTable from 'jspdf-autotable';
import jsPDF from "jspdf";
import moment from "moment"

import { Paper, Table, TableBody, TableContainer } from '@mui/material';

import { buttonsFocus, hasAccess, jsPdfDidParseCellCallback, jsPdfHeaderFooter, jsPdfWillDrawCellCallback } from '../../../components/generics/helper';
import { Loader } from '../../../components/generics/Loader';
import { callAddFontNirmalaBold } from '../../../styles/fonts/Nirmala-bold';
import { callAddFontNirmalaNormal } from '../../../styles/fonts/Nirmala-normal';
import { excelConfig, filterHeaderXlDataStyle, filterHeaderXlStyle } from '../../../configs/excelConfig';
import { StyledTableRow, StyledTableCell } from "../../../components/Table/TableStyle";
import CommonTableHeaderRow from '../../../components/Table/CommonTableHeaderRow';
import excelExport from '../../../services/exports/export-excel';
import FuelReportPopup from './FuelReportPopup';

const FuelReportSummaryList = (props) => {
    const { filters, tableData } = props
    const { selectedRolesRights = [], adminType = 0 } = useSelector((state) => state.login?.userData);
    const userData = useSelector((state) => state.login.userData);

    const [isPdfLoaded, setIsPdfLoaded] = useState(false);
    const [isPdfLoading, setIsPdfLoading] = useState(false);
    const [showMoreDetails, setShowMoreDetails] = useState(false);
    const [selectedVehicleDetails, setSelectedVehicleDetails] = useState(null);

    let columnDefs = [
        { headerName: 'Vehicle Number', field: 'vehicleNo', headerSx: { width: '7.6%' }, xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false },
        { headerName: 'Vehicle Code', field: 'vehicleCode', headerSx: { width: "7.6%", textAlign: 'left' }, xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, sx: { textAlign: "left" }, allowSorting: false },
        { headerName: 'Total Qty', field: 'qty', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false, },
        { headerName: 'Bill Amount', field: 'billAmount', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'currency', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
        { headerName: 'Run KM', field: 'runKM', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
        { headerName: 'Average', field: 'avg', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
    ];

    const getFilterSectionData = () => {
        const fuelStoreColumns = [
            { header: 'Fuel Store Name', dataKey: 'fuelStoreName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
            { header: 'Fuel Item', dataKey: 'fuelItemName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
            { header: 'Bill No', dataKey: 'billNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
        ]
        const fuelStationColumns = [
            { header: 'Fuel Station Name', dataKey: 'fuelStationName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
            { header: 'Fuel Type', dataKey: 'fuelTypeName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
            { header: 'Bill No', dataKey: 'billNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
        ]
        const allColumns = [
            { header: 'Bill No', dataKey: 'billNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
        ]
        const combinedColumns = [
            { header: 'Report Type', dataKey: 'reportFor', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
            { header: 'Fuel From Date', dataKey: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
            { header: 'Fuel To Date', dataKey: 'toDate', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
            { header: 'Vehicle No.', dataKey: 'vehicleNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
            { header: 'Fuel From', dataKey: 'fuelFrom', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
        ]
        if (filters.fuelIssuedFrom === 1) {
            combinedColumns.push(...fuelStoreColumns)
        } else if (filters.fuelIssuedFrom === 2) {
            combinedColumns.push(...fuelStationColumns)
        } else {
            combinedColumns.push(...allColumns)
        }
        return {
            filterHeaderXlStyle,
            filterHeaderXlDataStyle,
            filterData: [
                {
                    columns: combinedColumns,
                    pdfColumnStyles: {
                        0: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        1: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        2: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        3: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        4: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        5: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        6: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        7: { cellWidth: 50, halign: 'left', fontSize: 10 },
                    },
                    data: [
                        {
                            reportFor: filters.searchReportViewName,
                            fromDate: moment(filters.fromDate).format('DD-MMM-YY'),
                            toDate: moment(filters.toDate).format('DD-MMM-YY'),
                            vehicleNo: filters.searchVehicleIds === '' ? 'All Vehicles' : filters.searchVehicleNos.length === 1 ? filters.searchVehicleNos[0] : `Multiple [${filters.searchVehicleNos.length}]`,
                            fuelFrom: filters.fuelIssuedFrom === "" ? 'All' : filters.fuelIssuedFrom === 1 ? 'Fuel Store' : filters.fuelIssuedFrom === 2 ? 'Fuel Station' : '',
                            fuelStoreName: filters.searchStoreNames.length === 0 ? 'All Fuel Stores' : filters.searchStoreNames.length === 1 ? filters.searchStoreNames[0] : `Multiple [${filters.searchStoreNames.length}]`,
                            fuelItemName: filters.searchItemNames.length === 0 ? 'All Fuel Items' : filters.searchItemNames.length === 1 ? filters.searchItemNames[0] : `Multiple [${filters.searchItemNames.length}]`,
                            fuelStationName: filters.searchFuelStationNames.length === 0 ? 'All Fuel Stations' : filters.searchFuelStationNames.length === 1 ? filters.searchFuelStationNames[0] : `Multiple [${filters.searchFuelStationNames.length}]`,
                            fuelTypeName: !filters.searchFuelStationTypes || filters.searchFuelStationTypes === '' ? 'All Fuel Types' : filters.searchFuelStationTypeNames.join(', '),
                            billNo: filters.searchBillNo,
                        }
                    ]
                },
            ]
        }
    }
    const printReport = () => {
        try {
            const filterSectionData = getFilterSectionData();
            setIsPdfLoading(true);
            setIsPdfLoaded(false);
            const pdfColumns = columnDefs.filter((col) => !col.hideForExport).map((col) => {
                return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol }
            });
            const pdfData = tableData?.map((item) => ({
                ...item,
                'fuelType-ItemName': item.issuedFrom === 1 ? item.itemName : item?.fuelTypeTitle,
                'fuelStation-FuelStore': item.issuedFrom === 1 ? item.storeName : item?.fuelStationName,
            }))
            jsPDF.API.events.push(["addFonts", callAddFontNirmalaBold]);
            jsPDF.API.events.push(["addFonts", callAddFontNirmalaNormal]);
            const doc = new jsPDF({
                orientation: 'l',
                format: 'a3',
            });
            var totalPagesExp = '{total_pages_count_string}';
            doc.autoTableSetDefaults({
                headStyles: { fontSize: 9, halign: 'left', fillColor: [30, 89, 167], },
            });

            doc.setProperties({
                title: `FuelReportSummaryList-${moment().format('DD-MMM-YY-HH-mm')}.pdf`,
                subject: "Fuel Report Summary View",
                author: "Maven Tech Labs Pvt. Ltd.",
                keywords: "maven tech, Maintenance system, fuel report",
                creator: "MTLPL",
            });

            autoTable(doc, {
                margin: { top: 20, left: 5, right: 5, bottom: 5 },
                columns: filterSectionData.filterData[0].columns,
                body: filterSectionData.filterData[0].data,
                columnStyles: filterSectionData.filterData[0].pdfColumnStyles,
                theme: 'grid',
                tableWidth: 'wrap',
            });

            doc.line(0, doc.lastAutoTable.finalY + 2, doc.getPageWidth(), doc.lastAutoTable.finalY + 2);
            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 4,
                margin: { top: 2, left: 5, right: 5, bottom: 5 },
                alternateRowStyles: {
                    fillColor: [255, 255, 255]
                },
                columns: pdfColumns,
                body: pdfData,
                columnStyles: {
                    0: { minCellWidth: 26, fontSize: 8 },
                    1: { minCellWidth: 26, fontSize: 8 },
                    2: { minCellWidth: 26, fontSize: 8, halign: 'right' },
                    3: { minCellWidth: 26, fontSize: 8, halign: 'right' },
                    4: { minCellWidth: 26, fontSize: 8, halign: 'right' },
                    5: { minCellWidth: 26, fontSize: 8, halign: 'right' },
                },
                theme: 'grid',
                showHead: 'everyPage',
                headStyles: {
                    fillColor: [30, 89, 167],
                },
                didParseCell: (data) => {
                    jsPdfDidParseCellCallback(data, pdfColumns);
                },
                willDrawCell: (data) => {
                    jsPdfWillDrawCellCallback(data);
                },
                didDrawPage: function (data) {
                    data.settings.margin.top = 16;
                    const reportTitle = `Maintenance System | Fuel Report Summary View`
                    jsPdfHeaderFooter(data, reportTitle, userData, totalPagesExp);
                },
            },
            );
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp)
            }
            setIsPdfLoaded(true);
            setTimeout(() => {
                // document.getElementById('output').data = doc.output('datauristring', 'FuelReportSummaryList.pdf');
                const blob = doc.output('blob');
                const url = URL.createObjectURL(blob);
                document.getElementById('output').data = url;
                setIsPdfLoading(false);
            }, 1000);
        } catch (err) {
            console.log(err);
            setIsPdfLoading(false);
            setIsPdfLoaded(false);
        }
    }
    const backToScreenView = () => {
        setIsPdfLoaded(false);
    }
    const reportExcelExport = async () => {
        try {
            const filterSectionData = getFilterSectionData();
            setIsPdfLoading(true);
            const xlColumns = columnDefs.filter((col) => !col.hideForExport).map((col) => {
                return { colHeader: col.headerName, field: col.field, xlCol: col.xlCol }
            });
            const excelData = tableData?.map((item) => ({
                ...item,
                'fuelType-ItemName': item.issuedFrom === 1 ? item.itemName : item?.fuelTypeTitle,
                'fuelStation-FuelStore': item.issuedFrom === 1 ? item.storeName : item?.fuelStationName,
            }))
            const reportTitle = `Maintenance System | ${filters?.searchReportViewName} Fuel Report`
            const xlConfig = {
                ...excelConfig,
                columns: xlColumns,
                fileName: `Fuel_Report_Summary_List${moment(new Date()).format("DD_MMM_YYYY_ddd_HH_mm")}.xlsx`,
                showFilterSection: true,
                filterSectionData,
                workSheetTitle: `Fuel Report Summary View`,
                headerFooter: {
                    firstHeader: `&L&14&K104FA2 ${reportTitle} &R&B&12 Company Name: ${userData.companyName}`,
                    firstFooter: `&L&12 Report By : ${userData.userFullName}  [ ${userData.branchName} ] &C&12 Report Time :  ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")} &R&12 Page: &P of &N`
                },
                sheetHeaderData: [{
                    "caption": "Report Name :",
                    "value": `${filters?.searchReportViewName} - Fuel Report`,
                    "colSpan": 7
                }, {
                    "caption": "Company Name :",
                    "value": userData.companyName,
                    "colSpan": 6
                }],
            };
            await excelExport.processExcel(xlConfig, excelData);
            setIsPdfLoading(false);
        } catch (err) {
            console.log(err);
            setIsPdfLoading(false);
        }
    }

    const handleMoreDetails = (e, row) => {
        e.stopPropagation();

        const vehicleFilters = {
            vehicleId: row.vehicleId,
            vehicleNo: row.vehicleNo || '-',
            vehicleCode: row.vehicleCode,
        };

        setSelectedVehicleDetails(vehicleFilters);
        setShowMoreDetails(true);
    };

    const hideMoreDetails = () => {
        setShowMoreDetails(false);
        setSelectedVehicleDetails(null);
    }

    return (
        <>
            {tableData.length > 0 && <>
                <div className='report--header--container'>
                    <div key="fr_report_name" className='report--for--heading'>Report View : {filters.searchReportViewName}</div>
                    <div key="fr_report_action_container" className="report-export-button--container">
                        {!isPdfLoaded && <>
                            {hasAccess(selectedRolesRights, '4082', adminType) && <div key="fr_xls_btn" id="cssEpExCel" tabIndex={0} className="dashed--btn" onClick={() => reportExcelExport()} onKeyDown={(e) => buttonsFocus(e, reportExcelExport, `cssEpAsPDF`, `cssfSearchBtn`, "EX", "cssfSearchBtn")}> EXPORT AS EXCEL </div>}
                            {hasAccess(selectedRolesRights, '4083', adminType) && <div key="fr_xpdf_btn" id="cssEpAsPDF" tabIndex={0} className="dashed--btn" onClick={() => printReport()} onKeyDown={(e) => buttonsFocus(e, printReport, `cssEpExPDF`, `cssEpExCel`, null)}> EXPORT AS PDF </div>}
                            {hasAccess(selectedRolesRights, '4081', adminType) && <div key="fr_prn_btn" id="cssEpExPDF" tabIndex={0} className="dashed--btn" onClick={() => printReport()} onKeyDown={(e) => buttonsFocus(e, printReport, `cssSumList0`, `cssEpAsPDF`, null)}> PRINT </div>} </>}
                        {isPdfLoaded && <><div key="fr_backBtn" className="dashed--btn" onClick={() => backToScreenView()}> Back </div> </>}
                        {isPdfLoading && <div key="fr_loading_container" style={{ width: "100px", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
                    </div>
                </div>
                {!isPdfLoaded && !isPdfLoading && <>
                    <TableContainer component={Paper} className="jc--scroll jobCrdPreviewModel" style={{ maxHeight: '500px' }}>
                        <Table sx={{ minWidth: 1300 }} stickyHeader aria-label="sticky table">
                            <CommonTableHeaderRow columnDefs={columnDefs} />
                            <TableBody>
                                {tableData && tableData.length ? tableData.map((row, index) => (
                                    row.isDataRow ?
                                        <StyledTableRow key={`${row.rowType}-D-${index}`} className="grid">
                                            <StyledTableCell>{row.vehicleNo}</StyledTableCell>
                                            <StyledTableCell>{row.vehicleCode}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "right" }} className="text" tabIndex={0} onClick={(e) => handleMoreDetails(e, row)}>{row.qty || ''}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "right" }}>{row.billAmount}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "right" }}>{row.runKM}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "right" }}>{row.avg}</StyledTableCell>
                                        </StyledTableRow>
                                        :
                                        row.isTotalRow &&
                                        <StyledTableRow key={`${row.rowType}-T-${index}`} style={{ background:row.rowColor?.hex || '#e4ebf5' }} className="grid">
                                            <StyledTableCell colSpan={row.colSpan} style={{ textAlign: "left", fontWeight: "700" }}>{row.totalCaption}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "right" }}>{row.qty}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "right" }}>{row.billAmount}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "right" }}>{row.runKM}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "right" }}>{row.avg}</StyledTableCell>
                                        </StyledTableRow>)) :
                                    <StyledTableRow key={`$fr_no_records_row`}>
                                        <StyledTableCell style={{ width: "100%" }} colSpan={columnDefs.length} align="center">
                                            <div key="fr_no_records" className='no--records'> No Records </div>
                                        </StyledTableCell>
                                    </StyledTableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>}
            </>}

            {isPdfLoaded && <object id="output" type="application/pdf" width="100%" height="600" title="MTLPL - Maintenance System - Fuel Report Summary View" aria-label="MTLPL - Maintenance System - Fuel Report Summary View"></object>}
            {showMoreDetails && selectedVehicleDetails && (<FuelReportPopup selectedVehicleDetails={selectedVehicleDetails} handleModal={hideMoreDetails} filters={filters} />)}
        </>
    )
}

export default FuelReportSummaryList
